import React, { useState, useEffect} from 'react';
import { useSelector } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography';
import { ListItemIcon } from '@material-ui/core';
import Book from '@material-ui/icons/Book';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles(theme => ({
    copieAvailable: {
        color: '#008000',
    },
    copieNotAvailable: {
        color: '#ff3232',
    },
    copieEspecial: {
        color: '#e47826',
    }
}));

export default function Copie(props) {
    const classes = useStyles();
    const materialState = useSelector(state => state.material);
    const [materialStatus, setMaterialStatus] = useState({})
    const [materialSituation, setMaterialSituation] = useState({})
    const libraryState = useSelector(state => state.library)
    
    const getItemLibraryDescription = item => {
        const library = libraryState.list.find(library =>
            library['id-biblioteca'] === item['id-biblioteca']
        )

        return library ? library.descricao : ''
    }

    const getStatusStyle = (id = 'default') => {
        const styles = {
            '1': classes.copieAvailable,
            '2': classes.copieEspecial,
            'default': classes.copieNotAvailable,
        }
        return styles[id]
    }

    const getSituationsStyle = (id = 'default') => {
        const styles = {
            '1': classes.copieAvailable,
            '2': classes.copieNotAvailable,
            'default': classes.copieNotAvailable,
        }
        return styles[id]
    }

    useEffect(() => {
        setMaterialStatus(materialState.status.find(status => 
            status['id-status-material'] === props.item['id-status-material']
        ))

        setMaterialSituation(materialState.situations.find(situation => 
            situation['id-situacao-material'] === props.item['id-situacao-material']
        ))
    // eslint-disable-next-line react-hooks / exhaustive-deps
    }, [])

    return (
        <ListItem divider={true} dense={true}>
            {materialSituation && materialStatus &&
            <>
                <ListItemIcon>
                    <Book className={getSituationsStyle(materialSituation['id-situacao-material'])} />
                </ListItemIcon>   

                <ListItemText 
                    primary={
                        <>
                            <Typography
                                component="span"
                                variant="body2"
                                fontWeight="bold"
                            >
                                {getItemLibraryDescription(props['item'])}
                            </Typography><br />
                            Situação:&nbsp;
                            <Typography
                                component="span"
                                variant="body2"
                                className={
                                    getSituationsStyle(materialSituation['id-situacao-material'])
                                }
                            >
                                {materialSituation.descricao}
                            </Typography>
                        </>
                    }
                    secondary={
                        <>
                            Status:&nbsp;
                            <Typography
                                component="span"
                                variant="body2"
                                className={getStatusStyle(materialStatus['id-status-material'])}
                            >
                                {
                                    props.item['data-disponivel'] ?
                                    `Devolução prevista: ${props.item['data-disponivel']}` :
                                    materialStatus.descricao
                                }
                            </Typography><br />
                            Localização:&nbsp;
                            <Typography
                                component="span"
                                variant="body2"
                            >
                                {props['item'].localizacao}
                            </Typography>
                        </>
                    } 
                />

                {props.item['endereco-eletronico'] &&
                    <Button 
                        color="primary" 
                        className={classes.button}
                        href={props.item['endereco-eletronico']}
                        target="_blank"
                    >
                        <CloudDownloadIcon />
                    </Button>
                }
            </>
            }
        </ListItem>
    )
}